module.exports = __webpack_public_path__ + "static/media/take-away.3b773d36.png";